import { UserType } from '@/@types';
import React from 'react';
import UserCard from '@/components/core/components/molecules/user-card';
import { Scrollable } from '@/components/core/components/atoms/scrollable';
import * as styles from './carousel-user.styles';

const CarouselUser: React.FC<{ users: UserType[] }> = ({ users }) => {
  return (
    <Scrollable>
      <div className={styles.root}>
        {users.map((data: UserType) => {
          return <UserCard key={data.id} user={data} />;
        })}
      </div>
    </Scrollable>
  );
};

export default CarouselUser;
